// Update the following when adding/editing translations:
// https://ns90ltd.atlassian.net/wiki/spaces/3T/pages/4381540360/UI+translations
import { SUPPORTEDLANGUAGES } from "app/utils/const";
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/es";
import "dayjs/locale/pt";
import "dayjs/locale/zh";
import DayJS from "react-dayjs";
import * as EN from "./locales/en/en";
import * as esES from "./locales/es/es-es";
import * as ptBR from "./locales/pt/pt-br";
import * as ptPT from "./locales/pt/pt-pt";
import * as CN from "./locales/zh/zh-cn";

export function SetupTranslations(locale: string): any {
  const translations = Object.assign(
    EN.message,
    CN.message,
    esES.message,
    ptPT.message,
    ptBR.message
  );
  // modify global moment to use specific locale
  DayJS.globalMoment = dayjs;
  const languageCode = locale.split("-")[0];

  const foundLanguage = SUPPORTEDLANGUAGES.find(
    language => language.locale === locale
  );
  const bundle = foundLanguage ? foundLanguage.bundle : "en";
  DayJS.globalMoment.locale(languageCode);
  const messages = translations[bundle];
  return messages;
}

export const customDateFormats: any = Object.assign(
  EN.dateFormat,
  CN.dateFormat,
  esES.dateFormat
);
